module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "ui large centered inverted menu"
  }, [_c('v-link', {
    staticClass: "item",
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")]), _vm._v(" "), _c('v-link', {
    staticClass: "item",
    attrs: {
      "href": "/bio"
    }
  }, [_vm._v("Bio")]), _vm._v(" "), _c('v-link', {
    staticClass: "item",
    attrs: {
      "href": "/resume"
    }
  }, [_vm._v("Resume")]), _vm._v(" "), _c('a', {
    staticClass: "item",
    attrs: {
      "href": "https://www.github.com/nathancallen"
    }
  }, [_vm._v("\n        Github Page\n      ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "ui center aligned segment basic"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9cc11dba","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/Main.vue
// module id = 31
// module chunks = 0